
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models'
export type * from './prismaNamespace'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  User: 'User',
  Profile: 'Profile',
  Affiliate: 'Affiliate',
  Course: 'Course',
  Section: 'Section',
  Chapter: 'Chapter',
  Blog: 'Blog',
  Category: 'Category',
  Offering: 'Offering',
  StaticContent: 'StaticContent',
  Image: 'Image',
  Video: 'Video',
  ChapterView: 'ChapterView',
  ChapterShare: 'ChapterShare',
  ChapterCompletion: 'ChapterCompletion',
  BlogShare: 'BlogShare',
  CourseReview: 'CourseReview',
  ChapterLike: 'ChapterLike',
  BlogLike: 'BlogLike',
  Comment: 'Comment',
  CommentReaction: 'CommentReaction',
  Feedback: 'Feedback',
  MockReview: 'MockReview',
  SocialTestimonialScreenshot: 'SocialTestimonialScreenshot',
  UpworkTestimonialScreenshot: 'UpworkTestimonialScreenshot',
  UpworkStatScreenshot: 'UpworkStatScreenshot',
  Payment: 'Payment',
  Enrollment: 'Enrollment',
  Referral: 'Referral',
  Notification: 'Notification',
  UserNotification: 'UserNotification',
  NewsletterSubscription: 'NewsletterSubscription'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const UserScalarFieldEnum = {
  id: 'id',
  clerkId: 'clerkId',
  email: 'email',
  username: 'username',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]


export const ProfileScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  imageUrl: 'imageUrl',
  bio: 'bio',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ProfileScalarFieldEnum = (typeof ProfileScalarFieldEnum)[keyof typeof ProfileScalarFieldEnum]


export const AffiliateScalarFieldEnum = {
  id: 'id',
  referralCode: 'referralCode',
  commissionRate: 'commissionRate',
  totalRefClicks: 'totalRefClicks',
  isActive: 'isActive',
  paymentMethod: 'paymentMethod',
  phoneNumber: 'phoneNumber',
  bankName: 'bankName',
  accountHolder: 'accountHolder',
  accountNumber: 'accountNumber',
  iban: 'iban',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AffiliateScalarFieldEnum = (typeof AffiliateScalarFieldEnum)[keyof typeof AffiliateScalarFieldEnum]


export const CourseScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  title: 'title',
  subtitle: 'subtitle',
  description: 'description',
  originalPrice: 'originalPrice',
  discountedPrice: 'discountedPrice',
  isPublished: 'isPublished',
  staticContent: 'staticContent',
  thumbnailImageId: 'thumbnailImageId',
  trailerVideoId: 'trailerVideoId',
  categoryId: 'categoryId',
  teacherId: 'teacherId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CourseScalarFieldEnum = (typeof CourseScalarFieldEnum)[keyof typeof CourseScalarFieldEnum]


export const SectionScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  title: 'title',
  sortPosition: 'sortPosition',
  courseId: 'courseId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SectionScalarFieldEnum = (typeof SectionScalarFieldEnum)[keyof typeof SectionScalarFieldEnum]


export const ChapterScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  title: 'title',
  description: 'description',
  isFree: 'isFree',
  isPublished: 'isPublished',
  sortPosition: 'sortPosition',
  sectionId: 'sectionId',
  courseId: 'courseId',
  chapterVideoId: 'chapterVideoId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ChapterScalarFieldEnum = (typeof ChapterScalarFieldEnum)[keyof typeof ChapterScalarFieldEnum]


export const BlogScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  title: 'title',
  subtitle: 'subtitle',
  content: 'content',
  isPublished: 'isPublished',
  viewsCount: 'viewsCount',
  thumbnailImageId: 'thumbnailImageId',
  categoryId: 'categoryId',
  authorId: 'authorId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BlogScalarFieldEnum = (typeof BlogScalarFieldEnum)[keyof typeof BlogScalarFieldEnum]


export const CategoryScalarFieldEnum = {
  id: 'id',
  title: 'title',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CategoryScalarFieldEnum = (typeof CategoryScalarFieldEnum)[keyof typeof CategoryScalarFieldEnum]


export const OfferingScalarFieldEnum = {
  id: 'id',
  title: 'title',
  sortPosition: 'sortPosition',
  courseId: 'courseId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OfferingScalarFieldEnum = (typeof OfferingScalarFieldEnum)[keyof typeof OfferingScalarFieldEnum]


export const StaticContentScalarFieldEnum = {
  id: 'id',
  staticContent: 'staticContent',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StaticContentScalarFieldEnum = (typeof StaticContentScalarFieldEnum)[keyof typeof StaticContentScalarFieldEnum]


export const ImageScalarFieldEnum = {
  id: 'id',
  key: 'key',
  path: 'path',
  url: 'url',
  category: 'category',
  hostingService: 'hostingService',
  originalName: 'originalName',
  originalSize: 'originalSize',
  originalType: 'originalType',
  originalTimestamp: 'originalTimestamp',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ImageScalarFieldEnum = (typeof ImageScalarFieldEnum)[keyof typeof ImageScalarFieldEnum]


export const VideoScalarFieldEnum = {
  id: 'id',
  platform: 'platform',
  duration: 'duration',
  title: 'title',
  size: 'size',
  resolution: 'resolution',
  frameRate: 'frameRate',
  width: 'width',
  height: 'height',
  aspectRatio: 'aspectRatio',
  animatedGifUrl: 'animatedGifUrl',
  thumbnailUrl: 'thumbnailUrl',
  codecs: 'codecs',
  externalVideoId: 'externalVideoId',
  muxAssetId: 'muxAssetId',
  muxPlaybackId: 'muxPlaybackId',
  muxEncodingTier: 'muxEncodingTier',
  muxEncodingStatus: 'muxEncodingStatus',
  muxCreatedAt: 'muxCreatedAt',
  bunnyVideoGuid: 'bunnyVideoGuid',
  bunnyStatus: 'bunnyStatus',
  originalName: 'originalName',
  originalSize: 'originalSize',
  originalType: 'originalType',
  originalTimestamp: 'originalTimestamp',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type VideoScalarFieldEnum = (typeof VideoScalarFieldEnum)[keyof typeof VideoScalarFieldEnum]


export const ChapterViewScalarFieldEnum = {
  id: 'id',
  secondsWatched: 'secondsWatched',
  chapterId: 'chapterId',
  userId: 'userId',
  watchedAt: 'watchedAt'
} as const

export type ChapterViewScalarFieldEnum = (typeof ChapterViewScalarFieldEnum)[keyof typeof ChapterViewScalarFieldEnum]


export const ChapterShareScalarFieldEnum = {
  id: 'id',
  chapterId: 'chapterId',
  userId: 'userId',
  sharedAt: 'sharedAt'
} as const

export type ChapterShareScalarFieldEnum = (typeof ChapterShareScalarFieldEnum)[keyof typeof ChapterShareScalarFieldEnum]


export const ChapterCompletionScalarFieldEnum = {
  id: 'id',
  chapterId: 'chapterId',
  userId: 'userId',
  completedAt: 'completedAt'
} as const

export type ChapterCompletionScalarFieldEnum = (typeof ChapterCompletionScalarFieldEnum)[keyof typeof ChapterCompletionScalarFieldEnum]


export const BlogShareScalarFieldEnum = {
  id: 'id',
  blogId: 'blogId',
  userId: 'userId',
  sharedAt: 'sharedAt'
} as const

export type BlogShareScalarFieldEnum = (typeof BlogShareScalarFieldEnum)[keyof typeof BlogShareScalarFieldEnum]


export const CourseReviewScalarFieldEnum = {
  id: 'id',
  rating: 'rating',
  description: 'description',
  courseId: 'courseId',
  userId: 'userId',
  reviewedAt: 'reviewedAt',
  updatedAt: 'updatedAt'
} as const

export type CourseReviewScalarFieldEnum = (typeof CourseReviewScalarFieldEnum)[keyof typeof CourseReviewScalarFieldEnum]


export const ChapterLikeScalarFieldEnum = {
  id: 'id',
  chapterId: 'chapterId',
  userId: 'userId',
  likedAt: 'likedAt'
} as const

export type ChapterLikeScalarFieldEnum = (typeof ChapterLikeScalarFieldEnum)[keyof typeof ChapterLikeScalarFieldEnum]


export const BlogLikeScalarFieldEnum = {
  id: 'id',
  blogId: 'blogId',
  userId: 'userId',
  likedAt: 'likedAt'
} as const

export type BlogLikeScalarFieldEnum = (typeof BlogLikeScalarFieldEnum)[keyof typeof BlogLikeScalarFieldEnum]


export const CommentScalarFieldEnum = {
  id: 'id',
  content: 'content',
  chapterId: 'chapterId',
  blogId: 'blogId',
  courseId: 'courseId',
  userId: 'userId',
  parentCommentId: 'parentCommentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CommentScalarFieldEnum = (typeof CommentScalarFieldEnum)[keyof typeof CommentScalarFieldEnum]


export const CommentReactionScalarFieldEnum = {
  id: 'id',
  type: 'type',
  commentId: 'commentId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CommentReactionScalarFieldEnum = (typeof CommentReactionScalarFieldEnum)[keyof typeof CommentReactionScalarFieldEnum]


export const FeedbackScalarFieldEnum = {
  id: 'id',
  content: 'content',
  response: 'response',
  status: 'status',
  category: 'category',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FeedbackScalarFieldEnum = (typeof FeedbackScalarFieldEnum)[keyof typeof FeedbackScalarFieldEnum]


export const MockReviewScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  text: 'text',
  rating: 'rating',
  sortPosition: 'sortPosition',
  profileImageId: 'profileImageId',
  teacherId: 'teacherId',
  reviewedAt: 'reviewedAt',
  updatedAt: 'updatedAt'
} as const

export type MockReviewScalarFieldEnum = (typeof MockReviewScalarFieldEnum)[keyof typeof MockReviewScalarFieldEnum]


export const SocialTestimonialScreenshotScalarFieldEnum = {
  id: 'id',
  title: 'title',
  sortPosition: 'sortPosition',
  imageId: 'imageId',
  teacherId: 'teacherId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SocialTestimonialScreenshotScalarFieldEnum = (typeof SocialTestimonialScreenshotScalarFieldEnum)[keyof typeof SocialTestimonialScreenshotScalarFieldEnum]


export const UpworkTestimonialScreenshotScalarFieldEnum = {
  id: 'id',
  title: 'title',
  sortPosition: 'sortPosition',
  imageId: 'imageId',
  teacherId: 'teacherId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UpworkTestimonialScreenshotScalarFieldEnum = (typeof UpworkTestimonialScreenshotScalarFieldEnum)[keyof typeof UpworkTestimonialScreenshotScalarFieldEnum]


export const UpworkStatScreenshotScalarFieldEnum = {
  id: 'id',
  title: 'title',
  sortPosition: 'sortPosition',
  imageId: 'imageId',
  teacherId: 'teacherId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UpworkStatScreenshotScalarFieldEnum = (typeof UpworkStatScreenshotScalarFieldEnum)[keyof typeof UpworkStatScreenshotScalarFieldEnum]


export const PaymentScalarFieldEnum = {
  id: 'id',
  phoneNumber: 'phoneNumber',
  city: 'city',
  age: 'age',
  gender: 'gender',
  paymentMethod: 'paymentMethod',
  amount: 'amount',
  currency: 'currency',
  status: 'status',
  receiptImageId: 'receiptImageId',
  courseId: 'courseId',
  userId: 'userId',
  referralId: 'referralId',
  paidAt: 'paidAt',
  decisionedAt: 'decisionedAt'
} as const

export type PaymentScalarFieldEnum = (typeof PaymentScalarFieldEnum)[keyof typeof PaymentScalarFieldEnum]


export const EnrollmentScalarFieldEnum = {
  id: 'id',
  status: 'status',
  courseId: 'courseId',
  userId: 'userId',
  paymentId: 'paymentId',
  enrolledAt: 'enrolledAt'
} as const

export type EnrollmentScalarFieldEnum = (typeof EnrollmentScalarFieldEnum)[keyof typeof EnrollmentScalarFieldEnum]


export const ReferralScalarFieldEnum = {
  id: 'id',
  amount: 'amount',
  status: 'status',
  courseId: 'courseId',
  userId: 'userId',
  affiliateId: 'affiliateId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ReferralScalarFieldEnum = (typeof ReferralScalarFieldEnum)[keyof typeof ReferralScalarFieldEnum]


export const NotificationScalarFieldEnum = {
  id: 'id',
  type: 'type',
  title: 'title',
  content: 'content',
  actionUrl: 'actionUrl',
  iconUrl: 'iconUrl',
  thumbnailUrl: 'thumbnailUrl',
  targetScope: 'targetScope',
  targetId: 'targetId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type NotificationScalarFieldEnum = (typeof NotificationScalarFieldEnum)[keyof typeof NotificationScalarFieldEnum]


export const UserNotificationScalarFieldEnum = {
  id: 'id',
  isRead: 'isRead',
  isDismissed: 'isDismissed',
  notificationId: 'notificationId',
  userId: 'userId',
  createdAt: 'createdAt',
  readAt: 'readAt'
} as const

export type UserNotificationScalarFieldEnum = (typeof UserNotificationScalarFieldEnum)[keyof typeof UserNotificationScalarFieldEnum]


export const NewsletterSubscriptionScalarFieldEnum = {
  id: 'id',
  email: 'email',
  firstName: 'firstName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type NewsletterSubscriptionScalarFieldEnum = (typeof NewsletterSubscriptionScalarFieldEnum)[keyof typeof NewsletterSubscriptionScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]

